import dayjs from 'dayjs';

export const FORMAT: string = 'DD/MM/YYYY';
export const NEW_FORMAT: string = 'YYYY-MM-DD';

export function getNextWeekMonday(): dayjs.Dayjs {
    return dayjs().startOf('week').add(7, 'days');
}

export interface WeekdayInfo {
    value: string;
    name: string;
}

export const WEEKDAY_INFO: WeekdayInfo[] = [
    { value: 'monday', name: 'lundi' },
    { value: 'tuesday', name: 'mardi' },
    { value: 'wednesday', name: 'mercredi' },
    { value: 'thursday', name: 'jeudi' },
    { value: 'friday', name: 'vendredi' },
];

export const DAYS_OF_THE_WEEK: string[] = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
];

export function getDisplayDeliveryDate(deliveryDate: string | dayjs.Dayjs): string {
    return dayjs(deliveryDate, FORMAT).format('D MMMM');
}
